import { OrderItemEntity, OrderItemEntityEventsName } from '@monolith/legacy/types/order';
import { ItemUpdatesProduct, OrderUpdates } from '@monolith/legacy/types/order-v2';

function getOrderItemsFromOrderEvents(itemsWithItemSetToZero: ItemUpdatesProduct[]) {
  const items: OrderItemEntity[] = [];
  itemsWithItemSetToZero.forEach((itemUpdated) => {
    const newOrderItem: OrderItemEntity = {
      type: 'order-items',
      id: itemUpdated.itemId,
      orderedProduct: {
        data: {
          images: [itemUpdated.productImage],
          fulfillableId: undefined,
          name: itemUpdated.productName,
          options: [],
          pageUrl: itemUpdated.productUrl,
          id: itemUpdated.itemId,
          type: 'ordered-products',
          sku: itemUpdated.sku,
        },
      },
      events: [
        {
          type: OrderItemEntityEventsName.ORDER_SPLIT,
          itemId: itemUpdated.itemId,
          oldQuantity: itemUpdated.oldQuantity,
          newQuantity: itemUpdated.newQuantity,
          oldMultipliedQuantity: itemUpdated.oldMultipliedQuantity,
          newMultipliedQuantity: itemUpdated.newMultipliedQuantity,
          unitPrice: itemUpdated.unitPrice,
          oldAmount: itemUpdated.oldAmount,
          newAmount: itemUpdated.newAmount,
        },
      ],
      internalId: null,
      batchQuantity: 0,
      unitQuantity: itemUpdated.newQuantity,
      unitPrice: itemUpdated.unitPrice,
      totalPrice: itemUpdated.newAmount,
      oldAmount: itemUpdated.oldAmount,
      oldMultipliedQuantity: itemUpdated.oldMultipliedQuantity,
      oldQuantity: itemUpdated.oldQuantity,
    };

    items.push(newOrderItem);
  });
  return items;
}

export const getItemsWithZeroQntFromOrderEvents = (orderEvents: OrderUpdates[]) => {
  const itemUpdatesWithZeroQnt: ItemUpdatesProduct[] = orderEvents
    .map((event) => {
      if (event.type === OrderItemEntityEventsName.ORDER_SPLIT) {
        return event.updates.itemUpdates.filter((update) => update.newQuantity === 0);
      } else {
        return [];
      }
    })
    .flat();

  if (itemUpdatesWithZeroQnt.length > 0) {
    return getOrderItemsFromOrderEvents(itemUpdatesWithZeroQnt);
  }

  return [];
};
